import { ActionTypeKeys, ActionTypes } from 'embed/actions'
import {
  ActionTypeKeys as ApplicationActionTypeKeys,
  ActionTypes as ApplicationActionTypes,
} from 'embed/actions/application'

import { isUuid } from 'embed/constants'
import { Filter, Product } from '@evenfinancial/even-ts-static'
import { DeepReadonly } from 'utility-types'

export type FiltersState = DeepReadonly<{
  [product in Product]?: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [filter in Filter]?: any
  }
}>

export const initialFiltersState: FiltersState = {
  [Product.CreditCard]: {},
  [Product.LifeInsurance]: {},
  [Product.Loan]: {},
  [Product.Deposits]: {},
}

export const findFilter = (filterKey: string): Filter | undefined =>
  Object.values(Filter).find((filter) => filter === filterKey)

const reducer = (state: FiltersState = initialFiltersState, action: ActionTypes | ApplicationActionTypes) => {
  switch (action.type) {
    case ApplicationActionTypeKeys.APPLICATION_FIELD_CHANGED: {
      const nextState = { ...state }
      const actionKeyIsUuid = isUuid(action.key)
      const filter = findFilter(action.key)

      if (filter !== undefined || actionKeyIsUuid) {
        nextState[action.product] = { ...state[action.product], [action.key]: action.value }
      }

      return nextState
    }
    case ActionTypeKeys.CLEAR_FILTERS: {
      const nextState = { ...state }

      // Instead of clearing all filters, we'll whitelist specific filters that should be cleared for each product type
      // to ensure we don't accidentally remove data we didn't want to remove (e.g. zipcode)
      if (action.product === Product.Deposits) {
        // For deposits, only clear the product sub-type
        nextState[action.product] = {
          ...nextState[action.product],
          [Filter.ProductSubType]: undefined,
        }
      }

      return nextState
    }
    case ActionTypeKeys.FILTERS_CHANGED:
    case ActionTypeKeys.NON_APPLICATION_FILTER_CHANGED: {
      const nextState = { ...state }

      // Zipcode changes should apply to all products
      if (action.filters[Filter.Zipcode] !== undefined) {
        Object.keys(Product).forEach((product) => {
          nextState[Product[product]] = { ...state[Product[product]], [Filter.Zipcode]: action.filters[Filter.Zipcode] }
        })
      }

      nextState[action.product] = { ...state[action.product], ...action.filters }
      return nextState
    }
    default:
      return state
  }
}

export default reducer
